var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarCircleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "Star-circle-icon-path-1",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-20.8%",
    y: "-16.7%",
    width: "141.7%",
    height: "141.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter2",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0",
    type: "matrix",
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M5.35626283,1.1072904 L3.89159253,4.3824062 L0.614589,4.90929417 C0.0269264914,5.00329296 -0.208587109,5.80228269 0.217580359,6.25990839 L2.58841727,8.80777039 L2.0276706,12.4069347 C1.9267362,13.0575052 2.54804351,13.5448148 3.06841642,13.2405555 L6,11.5411563 L8.93158358,13.2405555 C9.45195649,13.5423411 10.0732638,13.0575052 9.9723294,12.4069347 L9.41158273,8.80777039 L11.7824196,6.25990839 C12.2085871,5.80228269 11.9730735,5.00329296 11.385411,4.90929417 L8.10840747,4.3824062 L6.64373717,1.1072904 C6.38130773,0.523508427 5.62093525,0.516087469 5.35626283,1.1072904 Z",
    id: "Star-circle-icon-path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Star-circle-icon-Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Add/Remove-Product",
    transform: "translate(-243.000000, -482.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "VX-Maintain-NEW-PRODUCT",
    transform: "translate(246.000000, 484.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon---validate"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Star-circle-icon-Oval-"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#Star-circle-icon-path-1"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#FFFFFF",
    strokeWidth: 1,
    strokeLinejoin: "square",
    fill: "#007AC9",
    fillRule: "evenodd",
    cx: 12,
    cy: 12,
    r: 11.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Warning",
    transform: "translate(6.000000, 4.500000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Star-circle-icon-path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Icon-color",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    xlinkHref: "#Star-circle-icon-path-3"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarCircleIcon);
export default __webpack_public_path__ + "static/media/StarCircleIcon.0a36dfdf.svg";
export { ForwardRef as ReactComponent };